export default "__VITE_ASSET__B72UV_0m__"